import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentcolor",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M32 39.28a7.281 7.281 0 1 1 7.281-7.281 7.28 7.28 0 0 1-7.28 7.281m0-19.602c-6.807 0-12.321 5.518-12.321 12.323S25.194 44.32 32 44.32c6.807 0 12.32-5.514 12.32-12.32 0-6.805-5.513-12.323-12.32-12.323" }),
      _createElementVNode("path", { d: "M58.357 32.796c-.465.672-11.536 16.47-26.358 16.47s-25.893-15.8-26.356-16.47a1.4 1.4 0 0 1 0-1.59C6.106 30.532 17.177 14.732 32 14.732s25.893 15.8 26.358 16.472c.331.479.331 1.11 0 1.59M58.659 1H5.341A4.34 4.34 0 0 0 1 5.342V58.66A4.34 4.34 0 0 0 5.341 63H58.66A4.34 4.34 0 0 0 63 58.66V5.342A4.34 4.34 0 0 0 58.66 1" })
    ], -1)
  ]))]))
}
export default { render: render }